module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/point_green-12109c90052276f95cbca9eb8befad3e.png";